






































import { computed, defineComponent } from '@vue/composition-api';
import { useRouter } from '@a/composables/use-router';
import RouteNames from '@a/router/routes';
import { useConfigurationApi } from '@a/plugins/configuration';
import { useI18N } from '@a/composables/use-vue-i18n';

export default defineComponent({
  name: 'OrderNavBar',
  props: {
    productName: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup: () => {
    const { router, route } = useRouter();
    const configurationApi = useConfigurationApi();
    const i18n = useI18N();

    const routesIndexMap = new Map<string, number>([
      [RouteNames.StepOneRoute, 1],
      [RouteNames.StepTwoRoute, 2],
      [RouteNames.StepThreeRoute, 3],
    ]);

    const onMenuItemClick = (
      event: Event,
      orderStep: { url: string; title: string; active: boolean; disabled: boolean },
    ): void => {
      if (orderStep.disabled) {
        event.preventDefault();
      }
    };

    const orderSteps = computed<Array<{
      url: string; title: string; active: boolean; disabled: boolean
    }>>(() => {
      // --- as long as product key is not present, we dont render order steps
      if (!('productKey' in router.currentRoute.params)) return [];

      const languagePrefix = configurationApi.getRouteLanguage();
      const territoryPrefix = configurationApi.getRouteTerritory();

      const routeParams = {
        productKey: router.currentRoute.params.productKey,
        languagePrefix,
        territoryPrefix,
        regionPrefix: configurationApi.data.routes.regionPrefix,
      };

      const currentIndex = routesIndexMap.get(router.currentRoute.name);

      return [
        {
          title: i18n.t('checkout:navigation.steps.one'),
          disabled: false, // --- it should be always possible to go back to step one
          active: route.value.matched
            .find((record) => record.name === RouteNames.StepOneRoute) !== undefined,
          url: router.resolve({
            name: RouteNames.StepOneRoute,
            params: routeParams,
          }).href,
        },
        {
          title: i18n.t('checkout:navigation.steps.two'),
          // --- step two should only be available to step two itself
          disabled: currentIndex !== routesIndexMap.get(RouteNames.StepTwoRoute),
          active:
            route.value.matched
              .find((record) => record.name === RouteNames.StepTwoRoute) !== undefined,
          url: router.resolve({
            name: RouteNames.StepTwoRoute,
            params: routeParams,
          }).href,
        },
        {
          title: i18n.t('checkout:navigation.steps.three'),
          disabled: currentIndex !== routesIndexMap.get(RouteNames.StepThreeRoute),
          active:
            route.value.matched
              .find((record) => record.name === RouteNames.StepThreeRoute) !== undefined,
          url: router.resolve({
            name: RouteNames.StepThreeRoute,
            params: routeParams,
          }).href,
        },
      ];
    });

    return {
      routesIndexMap,
      orderSteps,
      onMenuItemClick,
    };
  },
});
